import { z } from 'zod';

import { type SsoCompletePayload } from '@/modules/api';
import { deriveSignedDocuments, type LegalDocumentGroup } from '@/modules/legalDocuments';
import { formatBirthdayForData, getServerLocale, getSystemLocale } from '@/modules/localization';

import { accountSchema } from '../schema/accountSchema';

type FormValues = z.infer<typeof accountSchema>;

export const buildSsoCompletePayload = (
  values: FormValues,
  legalGroups: LegalDocumentGroup[]
): SsoCompletePayload => ({
  dob: formatBirthdayForData(values.birthday),
  password: values.password,
  smsAllowed: values.sms ?? false,
  preferredLanguage: getServerLocale(getSystemLocale()),
  signedDocuments: deriveSignedDocuments(values.agreements, legalGroups),
});
